import { useAppSelector } from '~/redux/hooks';

export type IPermission = {
  [field: string]: boolean;
};

const EMPTY_PERMISSIONS: IPermission = {};

const usePermission = () => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  const { profile } = useAppSelector((state) => state.auth);
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function
  return profile.permissions ?? EMPTY_PERMISSIONS;
};

export default usePermission;
